module.exports = __webpack_public_path__ + "img/582410_83381A_1F0C04_30140A-256px.007a5813.png";